(function () {
  const normalize = (str) =>
    (str || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "");
  const WRAPPER_SELECTOR = "[data-personalizacao-wrapper]";
  const INPUT_SELECTOR = "[data-personalizacao-input]";
  const CART_FORM_SELECTOR = 'form[action*="/cart/add"]';
  const RADIOS_SELECTOR =
    "variant-picker input[type='radio'], swatches-variant-picker-component input[type='radio']";

  const asArray = (iterable) => Array.from(iterable || []);

  function getContext(element) {
    return element.closest(".product-details") || element.closest(".shopify-section") || document;
  }

  function getAllWrappers() {
    return asArray(document.querySelectorAll(WRAPPER_SELECTOR)).filter(
      (wrapper) => wrapper instanceof HTMLElement
    );
  }

  function getInputs(wrapper) {
    return asArray(wrapper.querySelectorAll(INPUT_SELECTOR)).filter(
      (input) => input instanceof HTMLInputElement || input instanceof HTMLTextAreaElement
    );
  }

  function getPersonalizacaoRadios(wrapper) {
    const context = getContext(wrapper);
    return asArray(context.querySelectorAll(RADIOS_SELECTOR)).filter(
      (radio) => radio instanceof HTMLInputElement && normalize(radio.name).includes("personalizacao")
    );
  }

  function isPersonalizacaoEnabled(wrapper) {
    const radios = getPersonalizacaoRadios(wrapper);
    if (!radios.length) return false;
    const checked = radios.find((radio) => radio.checked);
    return !!checked && normalize(checked.value) === "sim";
  }

  function getFormForWrapper(wrapper) {
    const context = getContext(wrapper);
    const forms = asArray(context.querySelectorAll(CART_FORM_SELECTOR)).filter(
      (form) => form instanceof HTMLFormElement
    );
    if (!forms.length) return null;

    const wrapperProductId = (wrapper.dataset.productId || "").trim();
    if (wrapperProductId) {
      const matched = forms.find((form) => {
        const component = form.closest("product-form-component");
        return component?.dataset.productId === wrapperProductId;
      });
      if (matched) return matched;
    }

    return forms[0];
  }

  function getWrapperForForm(form) {
    const wrappers = getAllWrappers();
    if (!wrappers.length) return null;

    const formProductId = (form.closest("product-form-component")?.dataset.productId || "").trim();
    if (formProductId) {
      const sameProductWrappers = wrappers.filter(
        (wrapper) => (wrapper.dataset.productId || "").trim() === formProductId
      );
      if (sameProductWrappers.length === 1) return sameProductWrappers[0];
      if (sameProductWrappers.length > 1) {
        const formDetails = form.closest(".product-details");
        return (
          sameProductWrappers.find((wrapper) => wrapper.closest(".product-details") === formDetails) ||
          sameProductWrappers[0]
        );
      }
    }

    const formDetails = form.closest(".product-details");
    const sameDetailsWrapper = wrappers.find((wrapper) => wrapper.closest(".product-details") === formDetails);
    if (sameDetailsWrapper) return sameDetailsWrapper;

    const formSection = form.closest(".shopify-section");
    const sameSectionWrapper = wrappers.find((wrapper) => wrapper.closest(".shopify-section") === formSection);
    if (sameSectionWrapper) return sameSectionWrapper;

    return wrappers[0];
  }

  function removeHiddenProperties(form) {
    form.querySelectorAll('input[name^="properties["]').forEach((element) => {
      if (element.dataset.personalizacaoHidden) element.remove();
    });
  }

  function setFieldError(input, hasError) {
    const field = input.closest(".personalizacao-field");
    if (field instanceof HTMLElement) {
      field.classList.toggle("personalizacao-field--error", hasError);
    }

    if (hasError) {
      input.setAttribute("aria-invalid", "true");
    } else {
      input.removeAttribute("aria-invalid");
    }
  }

  function showError(wrapper, show) {
    const errorNode = wrapper.querySelector("[data-personalizacao-error]");
    if (errorNode instanceof HTMLElement) {
      errorNode.hidden = !show;
    }
  }

  function setInputsRequired(wrapper, required) {
    getInputs(wrapper).forEach((input) => {
      if (required) {
        input.setAttribute("aria-required", "true");
      } else {
        input.removeAttribute("aria-required");
      }
    });
  }

  function clearInputs(wrapper) {
    getInputs(wrapper).forEach((input) => {
      input.value = "";
      setFieldError(input, false);
    });
    showError(wrapper, false);
  }

  function syncPropertiesIntoForm(form, wrapper) {
    removeHiddenProperties(form);

    getInputs(wrapper).forEach((input) => {
      const value = input.value.trim();
      const propertyName = (input.dataset.propertyName || "").trim();

      if (!value || !propertyName) return;

      const hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = `properties[${propertyName}]`;
      hidden.value = value;
      hidden.dataset.personalizacaoHidden = "true";

      form.appendChild(hidden);
    });
  }

  function validatePersonalizacaoForForm(form, options = {}) {
    if (!(form instanceof HTMLFormElement)) return true;

    removeHiddenProperties(form);

    const wrapper = getWrapperForForm(form);
    if (!wrapper) return true;

    const enabled = isPersonalizacaoEnabled(wrapper);
    if (!enabled) {
      setInputsRequired(wrapper, false);
      clearInputs(wrapper);
      return true;
    }

    setInputsRequired(wrapper, true);

    const inputs = getInputs(wrapper).filter((input) => (input.dataset.propertyName || "").trim().length > 0);
    if (!inputs.length) return true;

    const invalidInputs = [];
    inputs.forEach((input) => {
      const empty = !input.value.trim();
      setFieldError(input, empty);
      if (empty) invalidInputs.push(input);
    });

    const hasInvalid = invalidInputs.length > 0;
    showError(wrapper, hasInvalid);

    if (hasInvalid) {
      if (options.focusFirstInvalid !== false) {
        invalidInputs[0]?.focus();
      }
      return false;
    }

    syncPropertiesIntoForm(form, wrapper);
    return true;
  }

  function updateWrapperVisibility(wrapper) {
    if (!(wrapper instanceof HTMLElement)) return;

    const enabled = isPersonalizacaoEnabled(wrapper);
    const form = getFormForWrapper(wrapper);

    if (!enabled) {
      wrapper.classList.add("forced-hide");
      setInputsRequired(wrapper, false);
      clearInputs(wrapper);
      if (form) removeHiddenProperties(form);
      return;
    }

    wrapper.classList.remove("forced-hide");
    setInputsRequired(wrapper, true);
  }

  function updateAllWrapperVisibility() {
    getAllWrappers().forEach(updateWrapperVisibility);
  }

  window.dropmetaValidatePersonalizacao = function (form) {
    return validatePersonalizacaoForForm(form);
  };

  document.addEventListener("change", function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    if (target.matches(RADIOS_SELECTOR) || target.closest(WRAPPER_SELECTOR)) {
      updateAllWrapperVisibility();
    }
  });

  document.addEventListener("input", function (event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement)) return;
    if (!target.matches(INPUT_SELECTOR)) return;

    setFieldError(target, !target.value.trim());
    const wrapper = target.closest(WRAPPER_SELECTOR);
    if (!(wrapper instanceof HTMLElement)) return;
    if (!isPersonalizacaoEnabled(wrapper)) {
      showError(wrapper, false);
      return;
    }

    const hasInvalid = getInputs(wrapper)
      .filter((input) => (input.dataset.propertyName || "").trim().length > 0)
      .some((input) => !input.value.trim());
    showError(wrapper, hasInvalid);
  });

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.querySelector('input[name="id"]')) return;

      if (!validatePersonalizacaoForForm(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    "click",
    function (event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const acceleratedTrigger = target.closest(
        ".shopify-payment-button__button, .shopify-payment-button__more-options, shopify-accelerated-checkout button, shopify-accelerated-checkout [role='button']"
      );
      if (!acceleratedTrigger) return;

      const form =
        acceleratedTrigger.closest("form") ||
        acceleratedTrigger.closest("product-form-component")?.querySelector(CART_FORM_SELECTOR);
      if (!(form instanceof HTMLFormElement)) return;

      if (!validatePersonalizacaoForForm(form)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener("DOMContentLoaded", updateAllWrapperVisibility);
  document.addEventListener("shopify:section:load", updateAllWrapperVisibility);
  document.addEventListener("shopify:section:reorder", updateAllWrapperVisibility);

  setTimeout(updateAllWrapperVisibility, 0);
})();
